(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function toggleSoftLoreFloatingVideo(card) {
    const video = card.querySelector('video');

    if (!video) return;

    if (video.paused) {
      video.muted = false;
      video.play();
    } else {
      video.pause();
    }
  }

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.softlore-hero-video-inset');

    if (!card) return;

    event.preventDefault();
    toggleSoftLoreFloatingVideo(card);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const card = event.target.closest('.softlore-hero-video-inset');

    if (!card) return;

    event.preventDefault();
    toggleSoftLoreFloatingVideo(card);
  });

  document.addEventListener('play', (event) => {
    const video = event.target;

    if (!(video instanceof HTMLVideoElement)) return;

    const card = video.closest('.softlore-hero-video-inset');

    card?.classList.add('is-playing');
    card?.setAttribute('aria-label', 'Pause Yizcho video');
  }, true);

  document.addEventListener('pause', (event) => {
    const video = event.target;

    if (!(video instanceof HTMLVideoElement)) return;

    const card = video.closest('.softlore-hero-video-inset');

    card?.classList.remove('is-playing');
    card?.setAttribute('aria-label', 'Play Yizcho video');
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softlore-kickstarter-start"] && !Shopify.designMode) return;
  try {
    
  const softLoreLaunchSection = document.querySelector('[data-softlore-kickstarter-start]');
  const softLoreHeader = document.querySelector('#header-component');
  const softLorePopupSelector = "[role='dialog']:has([data-testid^='klaviyo-form-'])";
  const softLorePopupCooldownKey = 'softlore_ks_popup_last_seen_v1';
  const softLorePopupCooldownMs = 5 * 24 * 60 * 60 * 1000;
  let softLoreAutoOpenRequested = false;
  let softLoreManualOpenRequestedAt = 0;
  let softLoreManualDialogSeen = false;
  let softLorePopupSyncFrame = 0;

  function softLoreReadLastPopupTime() {
    try {
      return Number(window.localStorage.getItem(softLorePopupCooldownKey)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function softLoreRememberPopupTime() {
    try {
      window.localStorage.setItem(softLorePopupCooldownKey, String(Date.now()));
    } catch (error) {
      return;
    }
  }

  function softLoreIsPopupVisible(dialog) {
    if (!dialog) return false;
    const style = window.getComputedStyle(dialog);
    const rect = dialog.getBoundingClientRect();
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number(style.opacity) > 0.01
      && rect.width > 0
      && rect.height > 0;
  }

  function softLoreOpenForm(formId, isManual) {
    if (!formId) return;

    if (isManual) {
      softLoreManualOpenRequestedAt = Date.now();
      softLoreManualDialogSeen = false;
      softLoreAutoOpenRequested = true;
      document.body.classList.add('softlore-popup-manual');
      softLoreRememberPopupTime();
    } else {
      softLoreAutoOpenRequested = true;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function softLoreSyncPopupState() {
    const dialog = document.querySelector(softLorePopupSelector);
    const isManual = document.body.classList.contains('softlore-popup-manual');
    const shouldBlock = !isManual && (
      !document.body.classList.contains('softlore-start-passed')
      || document.body.classList.contains('softlore-popup-cooldown')
    );

    if (shouldBlock) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      return;
    }

    if (softLoreIsPopupVisible(dialog)) {
      document.body.classList.add('klaviyo-prevent-body-scrolling');
      softLoreRememberPopupTime();
      if (isManual) softLoreManualDialogSeen = true;
      return;
    }

    if (isManual && softLoreManualDialogSeen) {
      document.body.classList.remove('softlore-popup-manual');
      softLoreManualDialogSeen = false;
    } else if (isManual && Date.now() - softLoreManualOpenRequestedAt > 5000) {
      document.body.classList.remove('softlore-popup-manual');
    }
  }

  function softLoreQueuePopupSync() {
    window.cancelAnimationFrame(softLorePopupSyncFrame);
    softLorePopupSyncFrame = window.requestAnimationFrame(softLoreSyncPopupState);
  }

  function softLoreUpdatePassedState() {
    if (!softLoreLaunchSection) return;
    const sectionBottom = softLoreLaunchSection.getBoundingClientRect().bottom;
    const hasPassed = sectionBottom <= window.innerHeight * 0.55;
    document.body.classList.toggle('softlore-start-passed', hasPassed);

    if (
      hasPassed
      && !document.body.classList.contains('softlore-popup-cooldown')
      && !softLoreAutoOpenRequested
    ) {
      const existingDialog = document.querySelector(softLorePopupSelector);
      if (existingDialog) {
        softLoreAutoOpenRequested = true;
      } else {
        const trigger = softLoreLaunchSection.querySelector('[data-softlore-open-form]');
        softLoreOpenForm(trigger?.getAttribute('data-softlore-open-form'), false);
      }
    }

    softLoreQueuePopupSync();
  }

  if (softLoreLaunchSection && softLoreHeader) {
    softLoreHeader.removeAttribute('transparent');
  }

  if (softLoreLaunchSection) {
    const lastPopupTime = softLoreReadLastPopupTime();
    const popupIsCoolingDown = lastPopupTime > 0 && Date.now() - lastPopupTime < softLorePopupCooldownMs;
    document.body.classList.toggle('softlore-popup-cooldown', popupIsCoolingDown);
    softLoreUpdatePassedState();
    window.addEventListener('scroll', softLoreUpdatePassedState, { passive: true });
    window.addEventListener('resize', softLoreUpdatePassedState);

    const popupObserver = new MutationObserver(softLoreQueuePopupSync);
    popupObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-softlore-open-form]');
    const floatingTrigger = event.target.closest('.softlore-launch-list-trigger');
    if (!trigger && !floatingTrigger) return;

    const formId = trigger?.getAttribute('data-softlore-open-form') || 'WwCY8q';
    if (!formId) return;

    softLoreManualOpenRequestedAt = Date.now();
    softLoreManualDialogSeen = false;
    softLoreAutoOpenRequested = true;
    document.body.classList.add('softlore-popup-manual');
    softLoreRememberPopupTime();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'kickstarter_start_cta_click',
      form_id: formId,
      page_path: window.location.pathname,
    });

    if (trigger) softLoreOpenForm(formId, true);
    softLoreQueuePopupSync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yizcho-grouped-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
